const basePath = '/api';

// Download invoice url
const downloadInvoiceUrl = (id, documentType) => `${basePath}/documentUrl/${documentType}/${id}`;
export default downloadInvoiceUrl;